import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeExternalProps as _mergeExternalProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("modal__el-1wrqk8", {
  backgroundColor: "#04050399",
  position: "fixed",
  zIndex: 2000000,
  padding: "60px 0",
  inset: 0,
  overflowY: "auto",
  display: "grid",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  justifyContent: "center",
  alignItems: "center",
  "&[data-state='open']": {
    animation: "static-styles-modal-kf-0xsqhb57 250ms forwards"
  },
  "&[data-state='closed']": {
    animation: "static-styles-modal-kf-1yrfyqlq 350ms forwards"
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none!important"
  }
});
const _staticStyles2 = _cssRef("modal__el-0p56oa", {
  backgroundColor: "white",
  zIndex: 140,
  width: "90vw",
  maxWidth: "450px",
  maxHeight: "85vh",
  padding: 25,
  "&[data-state='open']": {
    animation: "static-styles-modal-kf-12nijbob 360ms forwards"
  },
  "&[data-state='closed']": {
    animation: "static-styles-modal-kf-0qmhqupk 250ms forwards"
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none!important"
  },
  "&:focus": {
    outline: "none"
  }
});
const _staticStyles3 = _cssRef("modal__el-1bq8n4", {
  position: "absolute",
  fontFamily: "inherit",
  borderRadius: "100%",
  height: 32,
  width: 32,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  top: 10,
  right: 10,
  transition: "0.2s",
  backgroundColor: "#f3f4f6",
  border: "none",
  cursor: "pointer",
  color: "#9ca3af",
  "&:hover": {
    backgroundColor: "#e5e7eb",
    transform: "scale(1.1)"
  },
  "&:active": {
    transform: "scale(0.95)"
  }
});
import React from 'react';
import type { SerializedStyles } from "@terraindigital/static-styles-react";
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { DialogCloseProps, DialogContentProps } from '@radix-ui/react-dialog';
const overlayShow = "static-styles-modal-kf-0xsqhb57";
const overlayHide = "static-styles-modal-kf-1yrfyqlq";
const contentShow = "static-styles-modal-kf-12nijbob";
const contentHide = "static-styles-modal-kf-0qmhqupk";
export const Modal = DialogPrimitive.Root;
export const ModalTrigger = DialogPrimitive.Trigger;
export const ModalTitle = DialogPrimitive.Title;
export const ModalDescription = DialogPrimitive.Description;
type ModalContentProps = CustomProps<DialogContentProps> & {
  overlayCss?: SerializedStyles;
};

/* This component houses the modal content */

export const ModalContent = ({
  className,
  overlayCss,
  ...props
}: ModalContentProps): JSX.Element => <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay {..._mergeExternalProps({
    css: [_staticStyles, overlayCss]
  })}>
            <DialogPrimitive.Content {..._mergeExternalProps({
      css: _staticStyles2,
      className: className
    }, props)} />
        </DialogPrimitive.Overlay>
    </DialogPrimitive.Portal>;

/* this component closes the modal */

const XIcon = (): JSX.Element => <>
        <div className="modal__div-0y3z7e" />
        <div className="modal__div-3kfx35" />
    </>;
export const ModalCloseButton = ({
  className,
  children,
  ...props
}: CustomProps<DialogCloseProps>): JSX.Element => <DialogPrimitive.Close {..._mergeExternalProps({
  className: className,
  css: _staticStyles3
}, props)}>
        {children || <XIcon />}
    </DialogPrimitive.Close>;